export default __webpack_public_path__ + "static/media/ic-thrash-red.d0f2ee04.svg";